<template>
  <div>
    <base-title :title="StringLanguage.coupons">
      <!-- OCB
      <base-button @click="openDrawer()" class="d-show">
        <p class="plus">
          Adicionar cupom
        </p>
      </base-button>
      FIM OCB -->
      <base-button
        text="Abrir expirados e pausados"
        @click="$router.push({ name: 'cupons-expirados' })"
        design="two"
        :class="!!isMobile ? 'reverse ml_0 w-100' : 'ml_15 btn-expired'"
      />
    </base-title>

    <!-- OCB
    <div class="tabs mb_40">
      <ul>
        <li>
          <a @click="selectedTab = 0" :class="{ active: selectedTab == 0 }"
            >Divulgação Online</a
          >
        </li>
        <li :class="{ desk: selectedTab == 1 }">
          <a @click="selectedTab = 1" :class="{ active: selectedTab == 1 }"
            >Divulgação Offline</a
          >
        </li>
      </ul>
    </div>
    FIM OCB -->

    <!-- OCB
    <div v-if="selectedTab == 0" class="row mb_30">
      <div v-if="isMobile" class="col-lg-6 col-md-6 col-xs-12 mb_30">
        <base-add
          :text="StringLanguage.addCoupon"
          :height="'82px'"
          @click.native="openDrawer(DivulgationType.ONLINE)"
        />
      </div>
      <div
        v-for="coupon in onlineCoupons.coupons"
        :key="coupon.code"
        class="col-lg-6 col-md-6 col-xs-12"
      >
        <coupons-online-card :coupon="coupon" />
      </div>
      <div v-if="!isMobile" class="col-lg-6 col-xs-12">
        <base-add
          :text="StringLanguage.addCoupon"
          :height="'383px'"
          @click.native="openDrawer(DivulgationType.ONLINE)"
        />
      </div>
      <infinite-loading
        ref="infiniteOnlineCoupons"
        :identifier="0"
        spinner="wavedots"
        @infinite="getOnlineCoupons"
      >
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>
    FIM OCB -->

    <div class="row mb_30">
      <div v-if="isMobile" class="col-lg-4 col-md-6 col-xs-12 mb_30">
        <base-add
          :text="StringLanguage.addCoupon"
          :height="'120px'"
          @click.native="openDrawer(DivulgationType.OFFLINE)"
        />
      </div>
      <div v-if="!isMobile" class="col-lg-4 col-xs-12">
        <base-add
          :text="StringLanguage.addCoupon"
          :height="'194px'"
          @click.native="openDrawer(DivulgationType.OFFLINE)"
        />
      </div>
      <div
        v-for="coupon in offlineCoupons.coupons"
        :key="coupon.code"
        class="col-lg-4 col-md-6 col-xs-12"
      >
        <coupons-offline-card :coupon="coupon" />
      </div>
      <infinite-loading
        ref="infiniteOfflineCoupons"
        :identifier="1"
        spinner="wavedots"
        @infinite="getOfflineCoupons"
      >
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>

    <!-- OCB
    <base-empty
      v-if="
        onlineCoupons.coupons.length == 0 && offlineCoupons.coupons.length == 0
      "
      title="Você ainda não tem cupons cadastrados"
      message="Todos os seus cupons irão aparecer por aqui."
      buttonText="Adicionar cupom"
      @onClick="openDrawer()"
    />
    FIM OCB -->

    <base-empty
      v-if="
        onlineCoupons.coupons.length == 0 && offlineCoupons.coupons.length == 0
      "
      title="Você ainda não tem cupons cadastrados"
      message="Todos os seus cupons irão aparecer por aqui."
      buttonText="Adicionar cupom"
      @click.native="openDrawer(DivulgationType.OFFLINE)"
    />

    <coupons-step-form
      :divulgationProp="drawer.openStep"
      :open="drawer.open"
      :close="drawer.close"
      ref="couponForm"
      @onAddFinish="resetCoupons"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import InfiniteLoading from 'vue-infinite-loading';
import { DivulgationType } from 'easyjs/lib/Schema/Gift';
import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import BaseAdd from '@/components/Add';
import BaseDrawer from '@/components/Drawer';
import BaseCard from '@/components/Card';
import BaseLabel from '@/components/Label';
import BaseInput from '@/components/Input';
import BaseEmpty from '@/components/Empty';

import CouponsOfflineCard from '@/containers/Coupons/CouponsCard';
import CouponsOnlineCard from '@/containers/Coupons/CouponsOnlineCard';
import CouponsStepForm from '@/containers/Coupons/Forms/CouponsStepForm';

import GiftAPI from '@/api/coupon';

export default {
  data() {
    return {
      DivulgationType,
      onlineCoupons: { page: 1, coupons: [] },
      offlineCoupons: { page: 1, coupons: [] },
      selectedTab: 1,
      drawer: {
        open: false,
        close: false,
        openStep: '',
      },
    };
  },
  methods: {
    async getOnlineCoupons($state) {
      const coupons = await this.getCoupons(DivulgationType.ONLINE, this.onlineCoupons.page);
      if (coupons.length > 0) {
        this.onlineCoupons.coupons.push(...coupons);
        this.onlineCoupons.page++;
        $state.loaded();
      } else {
        $state.complete();
      }
    },
    async getOfflineCoupons($state) {
      const coupons = await this.getCoupons(DivulgationType.OFFLINE, this.offlineCoupons.page);
      if (coupons.length > 0) {
        this.offlineCoupons.coupons.push(...coupons);
        this.offlineCoupons.page++;
        $state.loaded();
      } else {
        $state.complete();
      }
    },
    getCoupons(divulgationType, page = 1, limit = 12) {
      return GiftAPI.list(false, divulgationType, page, limit).then(
        (response) => {
          return response.getData([]);
        }
      );
    },
    openDrawer(step = '') {
      this.drawer.open = !this.drawer.open;
      this.drawer.openStep = step;
    },
    closeDrawer() {
      this.drawer.close = !this.drawer.close;
    },
    resetCoupons() {
      this.closeDrawer();
      (this.onlineCoupons = { page: 1, coupons: [] }),
        (this.offlineCoupons = { page: 1, coupons: [] });
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
    }),
  },
  /* OCB
  mounted() {
    this.getOnlineCoupons();
    this.getOfflineCoupons();
  },
  FIM OCB */
  watch: {},
  components: {
    BaseTitle,
    BaseButton,
    BaseAdd,
    BaseDrawer,
    BaseCard,
    BaseLabel,
    BaseInput,
    BaseButton,
    BaseEmpty,
    CouponsOfflineCard,
    CouponsOnlineCard,
    CouponsStepForm,
    InfiniteLoading,
  },
};
</script>

<style scoped>
.plus {
  display: flex;
  align-items: center;
}
.plus i {
  font-size: 19px;
  margin-left: 15px;
}
.text-message-drawer {
  cursor: pointer;
  text-align: center;
  font-weight: bold;
  font-size: 1.2em;
  color: var(--default-hover);
}
.text-message-drawer:hover {
  text-decoration: underline;
}
.tabs ul li {
  display: inline;
  text-align: center;
}
.tabs a {
  cursor: pointer;
  display: inline-block;
  margin-right: 25px;
  margin-bottom: 6px;
  text-decoration: none;
  font-size: 1.4em;
  color: #999999ad;
  padding-bottom: 5px;
  border-bottom: 2px solid transparent;
}
.tabs a.active {
  color: var(--default);
  border-color: var(--default);
}
.btn-expired {
  z-index: 300;
}
</style>
